import { SlotMachineIcon } from './SlotMachineIcon';

/**
 * author: Michael Irigoyen
 * id 8DAEB736-3A62-475D-81A5-47BD881EA912
 * name slot-machine
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/slot-machine.svg
 * tags
 */
export const CasinoIcon = SlotMachineIcon;
export default CasinoIcon